module.exports = __webpack_public_path__ + "static/logo_wes-b3cc0549e77b7f522946aa01081f2868.svg";